import { buildProductCard } from "./etempa-build-klevu-product-card-v4.js";
import { buildPagination } from "./etempa-build-klevu-pagination.js";
// NOTE: relative ES imports aren't fingerprinted by Shopify's asset_url, so the
// CDN serves them from a long-lived cache. Bump this ?v= whenever
// etempa-build-klevu-filters.js changes, or the old version keeps being served.
import { buildFilterBlock, createActiveFilters } from "./etempa-build-klevu-filters.js?v=2";
import { showLoadingSpinner, arrayChunk } from "./etempa-klevu-helpers.js";
import { etempaKlevuSendCategoryData } from "./etempa-klevu-analytics-v2.js";
import { setShowValue } from "./etempa-klevu-set-show-value.js";

//js running

const pageAbortController = new AbortController();
window.addEventListener("pagehide", () => pageAbortController.abort());

const klevu_js_key = "klevu-163067900222714176";
const no_results_elem = document.getElementById("etempa-product-grid-no-results");
const error_elem = document.getElementById("etempa-product-grid-error");
const error_text_elem = document.getElementById("etempa-product-grid-error-text");

// const product_grid_container = document.querySelector(".collection");
const unorderedList = document.getElementById("product-grid");

const pagination_container = document.querySelector(".pagination");
const paginationList = document.querySelector(".pagination__list");
const pagination_previous = document.querySelector(".pagination--previous");
const pagination_next = document.querySelector(".pagination--next");
// const pagination_items = document.getElementById("etempa-collection-pagination-pages");

const show_by_items = document.querySelectorAll(".utils-showby-item");
const filter_form = document.querySelector("#FacetFiltersForm");
const sortBySelect = document.querySelector("[data-productgrid-trigger-sort]");
const mobile_filter_button = document.querySelector(".mobile-facets__disclosure");
const mobile_filter_text = mobile_filter_button.querySelector(".mobile-facets__open-label");
const priceData = {};
const filterMinMaxData = {};
// const product_items = [];

const sort_klevu_equivs = {
  manual: "RELEVANCE",
  "title-ascending": "NAME_ASC",
  "title-descending": "NAME_DESC",
  "price-ascending": "PRICE_ASC",
  "price-descending": "PRICE_DESC",
  "created-ascending": "NEW_ARRIVAL_ASC",
  "created-descending": "NEW_ARRIVAL_DESC",
};

let page = 1;
let limit = 36;
let view = "grid-view";
let sort = "manual";
let enabledFilters = [];
let currentFilters = [];

let priceRange = [];
let step;
let priceSlider;
let priceSliderContainer;
// let sliderInteraction = false;
let currencySymbol = "£";
let changeCurrency = false;
let modalFirstGroupHeightInterval;
let urlParams = new URLSearchParams(document.location.search);
if (urlParams.get("page")) page = Number(urlParams.get("page"));
if (urlParams.get("grid_list")) view = urlParams.get("grid_list");
if (urlParams.get("view")) limit = Number(urlParams.get("view").replace("view-", ""));
if (urlParams.get("sort_by")) sort = urlParams.get("sort_by");
currentFilters = urlParams.getAll("filter");

let cachedFilters = {};
try {
  const _cf = localStorage.getItem("klevuCollectionCachedFilters");
  if (_cf != undefined) cachedFilters = JSON.parse(_cf);
} catch (e) {
  localStorage.removeItem("klevuCollectionCachedFilters");
}
let lastInteraction = localStorage.getItem("klevuCollectionCachedInteraction");

if (cachedFilters?.collection_name != collection_name || currentFilters.length < 1) {
  cachedFilters = {};
  localStorage.removeItem("klevuCollectionCachedFilters");
  localStorage.removeItem("klevuCollectionCachedInteraction");
  lastInteraction = undefined;
}
cachedFilters.collection_name = collection_name;

getProducts(collection_name, klevu_js_key);
setShowValue(show_by_items, limit, currentFilters, urlParams);
// mobileFilterButtonEvent();
// windowResizeEvent();
setupSortBySelectChangeEvent();

function setupSortBySelectChangeEvent() {
  if (sortBySelect) {
    sortBySelect.addEventListener("change", (e) => {
      e.preventDefault();
      sort = sortBySelect.value;
      window.location.href = buildHref(1);
    });
  }
}

function getProducts(collection_name, klevu_js_key) {
  no_results_elem.style.display = "none";
  error_elem.style.display = "none";

  let request = {
    recordQueries: [
      {
        filters: {
          filtersToReturn: {
            enabled: true,
            exclude: ["variantid", "inventoryQuantity", "artist"],
            options: {
              order: "INDEX",
              limit: 999999,
            },
            rangeFilterSettings: [
              {
                key: "klevu_price",
                minMax: false,
                rangeInterval: 10,
              },
            ],
          },
        },
        id: "categoryProducts",
        typeOfRequest: "CATNAV",
        settings: {
          sort: sort_klevu_equivs[sort],
          query: {
            categoryPath: collection_name,
          },
          typeOfRecords: ["KLEVU_PRODUCT"],
          limit: limit,
          offset: page > 1 ? limit * (page - 1) : 0,
          groupCondition: {},
        },
      },
    ],
    context: {
      apiKeys: [klevu_js_key],
    },
  };

  //console.log('HERE');
  //console.log(request);

  if (currentFilters.length > 0) {
    request.recordQueries[0].settings.groupCondition = {
      groupOperator: "ALL_OF",
      conditions: [],
    };

    // Collect all selected price ranges to combine into a single min/max condition
    let priceRangeConditions = [];

    currentFilters.forEach((filter) => {
      let filterArray = filter.split("_");
      let filterKey = filterArray[0];
      let filterValue = decodeURIComponent(filterArray[1]);

      if (filterKey === "minMaxPrice") {
        let filterMin = Number(filterArray[1]);
        let filterMax = Number(filterArray[2]);
        priceRangeConditions.push({
          key: "klevu_price",
          valueOperator: "INCLUDE",
          singleSelect: false,
          values: [filterMin, filterMax],
        });
      } else {
        let conditionExistsIndex =
          request.recordQueries[0].settings.groupCondition.conditions.findIndex(
            (condition) => condition.key === filterKey,
          );
        if (conditionExistsIndex > -1) {
          request.recordQueries[0].settings.groupCondition.conditions[
            conditionExistsIndex
          ].values.push(filterValue);
        } else {
          request.recordQueries[0].settings.groupCondition.conditions.push({
            key: filterKey,
            valueOperator: "INCLUDE",
            singleSelect: false,
            values: [filterValue],
          });
        }
      }
    });

    // Combine all selected price ranges into a single min/max condition
    if (priceRangeConditions.length > 0) {
      let overallMin = Math.min(...priceRangeConditions.map((c) => c.values[0]));
      let overallMax = Math.max(...priceRangeConditions.map((c) => c.values[1]));
      request.recordQueries[0].settings.groupCondition.conditions.push({
        key: "klevu_price",
        valueOperator: "INCLUDE",
        singleSelect: false,
        values: [overallMin, overallMax],
      });
    }
  }

  runKlevuQuery(request);
}

function runKlevuQuery(request) {
  fetch(`https://rwcsv2.ksearchnet.com/cs/v2/search`, {
    method: "POST",
    // mode: 'cors',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
    signal: pageAbortController.signal,
  })
    .then((response) => {
      // console.log("RESPONSE: ", response);
      // console.log("RESPONSE collection: ", response.json);
      return response.json();
    })
    .then((data) => {
      if (data.meta.responseCode === 200) {
        if (data.queryResults[0]?.meta.noOfResults > 0 && data.queryResults[0].records.length > 0) {
          const allHandles = data.queryResults[0].records
            .filter((record) => {
              return record.url.includes("rarewaves");
            })
            .map((record) => {
              return record.url.split("/").pop();
            });
          // console.log(allHandles)
          const handles = arrayChunk(allHandles, 20);

          if (current_currency !== "GBP") {
            changeCurrency = true;
            let filterMax = 0;
            let filterMin = 0;
            data.queryResults[0].filters.forEach((filter) => {
              if (filter.key === "klevu_price" || filter.key === "Price Range") {
                filterMax = filter.max;
                filterMin = filter.min;
              }
            });

            handles.forEach((handleChunk, index) => {
              // console.log(handleChunk)
              let cacheBustingString = (Math.random() + 1).toString(36).substring(7);
              fetch(
                `/?handles=${handleChunk.join("_")}&sections=etempa-currency-conversion&max=${filterMax}&min=${filterMin}&type=${cacheBustingString}`,
                {
                  method: "GET",
                  // mode: 'cors',
                  headers: {
                    "Content-Type": "application/json",
                  },
                  signal: pageAbortController.signal,
                },
              )
                .then((sectionResponse) => sectionResponse.json())
                .then((sectionData) => {
                  let tempElem = document.createElement("div");
                  tempElem.innerHTML = sectionData["etempa-currency-conversion"];
                  let priceInfoArray = tempElem.querySelectorAll(".currency-conversion-price-info");
                  let filterInfoElem = tempElem.querySelector(".currency-conversion-filter-info");
                  if (priceInfoArray && priceInfoArray.length > 0) {
                    currencySymbol = priceInfoArray[0].getAttribute("data-product-price")[0];
                    priceInfoArray.forEach((priceInfo) => {
                      priceData[parseInt(priceInfo.getAttribute("data-product-id").trim())] = {
                        price: priceInfo.getAttribute("data-product-price"),
                        comparePrice: priceInfo.getAttribute("data-product-compare-price"),
                      };
                    });
                  }
                  if (filterInfoElem) {
                    filterMinMaxData.max = Number(
                      filterInfoElem.getAttribute("data-filter-max").trim(),
                    );
                    filterMinMaxData.min = Number(
                      filterInfoElem.getAttribute("data-filter-min").trim(),
                    );
                  }
                })
                .catch((error) => {
                  console.error(error);
                  error_elem.style.display = "block";
                  error_text_elem.innerText = error;
                });
            });
            let displayPriceDataCount = 0;
            const displayPriceData = setInterval(
              () => {
                // console.log('Object.keys(priceData).length', Object.keys(priceData).length)
                // console.log('allHandles.length',  allHandles.length);
                displayPriceDataCount++;

                if (
                  Object.keys(priceData).length == allHandles.length ||
                  displayPriceDataCount > 20
                ) {
                  clearInterval(displayPriceData);
                  constructProductsAndFilters(data);
                }
              },
              250,
              priceData,
              allHandles,
              data,
              displayPriceDataCount,
            );
          } else {
            constructProductsAndFilters(data);
          }

          if (
            data.queryResults[0]?.meta.noOfResults != data.queryResults[0]?.meta.totalResultsFound
          ) {
            // const pagination_container = document.querySelector(".pagination");
            // const paginationList = document.querySelector(".pagination__list");
            // const pagination_previous = document.querySelector(".pagination--previous");
            // const pagination_next = document.querySelector(".pagination--next");
            // // const pagination_items = document.getElementById("etempa-collection-pagination-pages");
            buildPagination(
              data.queryResults[0].meta.totalResultsFound,
              limit,
              page,
              paginationList,
              pagination_next,
              pagination_previous,
              pagination_container,
              buildHref,
            );
          } else {
            pagination_container.style.display = "none";
          }
        } else {
          no_results_elem.style.display = "block";
          pagination_container.style.display = "none";
        }
      } else {
        error_elem.style.display = "block";
        error_text_elem.innerText =
          "An error occurred while fetching this Collection. Please try again later.";
      }
    })
    .catch((error) => {
      console.error(error);
      error_elem.style.display = "block";
      error_text_elem.innerText = error;
    });
}

function constructProductsAndFilters(data) {
  let results = data.queryResults[0].records.filter((record) => record.url.includes("rarewaves"));

  unorderedList.innerHTML = "";
  window.klevuProducts = [];
  const fragment = document.createDocumentFragment();

  results.forEach((product) => {
    let link = `/collections/${collection_handle}/products/${product.url.split("/").pop()}`;
    const listItemClass = "grid__item";
    buildProductCard(
      collection_name,
      collection_handle,
      product,
      changeCurrency,
      priceData,
      currencySymbol,
      collection_section_id,
      departmentMetaObject,
      fragment,
      link,
      listItemClass,
    );
    window.klevuProducts.push(Number(product.id));
  });

  unorderedList.append(fragment);

  enabledFilters = [...(data.queryResults[0]?.filters || [])];

  // Klevu omits a filter type from its response once it's been applied as a condition.
  // Rebuild the filter list in the original cached order, restoring any missing active types.
  if (cachedFilters.filters?.length > 0) {
    const liveMap = new Map(enabledFilters.map((f) => [f.key, f]));
    const merged = cachedFilters.filters.map((cached) => liveMap.get(cached.key) || cached);
    // Append any brand-new filter types from Klevu not previously cached
    enabledFilters.forEach((liveFilter) => {
      if (!cachedFilters.filters.find((cf) => cf.key === liveFilter.key)) {
        merged.push(liveFilter);
      }
    });
    enabledFilters = merged;
  }

  let tmpCachedFilterArray = [];
  if (enabledFilters && Array.isArray(enabledFilters) && enabledFilters.length > 0) {
    let filtersToCache;
    enabledFilters.forEach((filter, index) => {
      filtersToCache = buildFilterBlock(
        filter,
        index,
        currentFilters,
        changeCurrency,
        filterMinMaxData,
        currencySymbol,
        priceRange,
        step,
        priceSlider,
        priceSliderContainer,
        // sliderInteraction,
        enabledFilters,
        cachedFilters,
        lastInteraction,
        buildHref,
        showLoadingSpinner,
      );
      if (filtersToCache != null) {
        tmpCachedFilterArray.push(filtersToCache);
      }
    });
    cachedFilters.filters = [...tmpCachedFilterArray];
    try {
      localStorage.setItem("klevuCollectionCachedFilters", JSON.stringify(cachedFilters));
    } catch (e) {
      localStorage.removeItem("klevuCollectionCachedFilters");
    }
    createActiveFilters(
      currentFilters,
      enabledFilters,
      currencySymbol,
      buildHref,
      collection_handle,
      setMobileFilterText,
    );
  }

  etempaKlevuSendCategoryData();
}

// function buildProductCard(collection_name, collection_handle, product) {
//   let link = `/collections/${collection_name}/products/${product.url.split("/").pop()}`;
//   let price = Number(product.salePrice);
//   let comparePrice = Number(product.price);

//   if (changeCurrency && priceData[product.id]) {
//     let priceString = priceData[product.id].price;
//     let comparePriceString = priceData[product.id].comparePrice;
//     price = parseFloat(priceString.replace(/[^0-9.,]/g, "").replace(",", "."));

//     if (comparePriceString && comparePriceString.trim() !== "") {
//       comparePrice = parseFloat(comparePriceString.replace(/[^0-9.,]/g, "").replace(",", "."));
//     } else {
//       comparePrice = price;
//     }
//   } else {
//     price = Number(product.salePrice);
//     comparePrice = Number(product.price);
//   }

//   let onSale = price < comparePrice ? true : false;
//   let discount;
//   let imageUrl = product.imageUrl;
//   let hasImage = imageUrl != "";
//   if (!hasImage) {
//     imageUrl = window.cardConfig.globalDefaultImageUrl;
//   }

//   let imageUrlTemplate = "";
//   // let preOrder = product.tags?.search("Pre-Order") >= 0 ? true : false;
//   let inStock = true;
//   if (product.inStock == "no" || product.inventoryQuantity === 0) {
//     inStock = false;
//   }

//   if (onSale) {
//     // Match sale-badge.liquid calculation logic
//     let saleSavings = comparePrice - price;
//     saleSavings = saleSavings * 1.0;
//     saleSavings = comparePrice / saleSavings;
//     discount = Math.round(100 / saleSavings);
//   }

//   if (hasImage) {
//     let imageUrlSplit = imageUrl.split(".");
//     let imageUrlExtension = imageUrlSplit.pop();
//     imageUrlTemplate = `${imageUrlSplit.join(".")}_{size}.${imageUrlExtension}`;
//   }

//   // Determine card classes based on Liquid logic from window.cardConfig
//   const hasProductImage = product.imageUrl && product.imageUrl !== "";
//   const hasMedia = hasProductImage || window.cardConfig.hasGlobalDefaultImage;

//   const cardClasses = [
//     "card",
//     `card--${window.cardConfig.cardStyle}`,
//     hasMedia ? "card--media" : "card--text",
//     window.cardConfig.cardStyle === "card" ? "gradient" : "",
//     !hasProductImage &&
//     window.cardConfig.cardStyle === "card" &&
//     !window.cardConfig.hasGlobalDefaultImage
//       ? "ratio"
//       : "",
//     window.cardConfig.horizontalClass ? "card--horizontal" : "",
//   ].filter(Boolean);

//   const ratioPercent = (1 / 1) * 100; // ratio = 1 in card-product.liquid

//   // Determine if product has linked products or variant swatches
//   const hasLinkedProducts = product.linkedProducts ? true : false;
//   const hasVariantSwatch =
//     product.options?.some((opt) =>
//       opt.toLowerCase().includes(window.cardConfig.productSwatchSearchTerm.toLowerCase()),
//     ) || false;

//   // Determine wrapper class based on swatches
//   const wrapperClass = !hasLinkedProducts && !hasVariantSwatch ? "product-card-no-swatch" : "";

//   // <li class="grid__item">
//   let li = document.createElement("li");
//   li.classList.add("grid__item");

//   // <product-card data-original-product-id...>
//   let productItem = document.createElement("product-card");
//   productItem.setAttribute("data-original-product-id", product.id);
//   productItem.setAttribute("data-original-product-variant-id", product.variantid);
//   productItem.setAttribute("data-has-linked-products", hasLinkedProducts);
//   productItem.setAttribute("data-has-variant-swatch", hasVariantSwatch);
//   productItem.setAttribute("data-add-to-cart-text", window.productTexts.addToCart);
//   productItem.setAttribute("data-order-sample-text", window.productTexts.orderSample);
//   productItem.setAttribute("data-sold-out-text", window.productTexts.soldOut);
//   productItem.setAttribute("data-product-quickshop-url", collection_handle);
//   li.append(productItem);

//   // <div class="card-wrapper product-card-wrapper">
//   let productItemContainer = document.createElement("div");
//   productItemContainer.classList.add("card-wrapper", "product-card-wrapper", wrapperClass);
//   productItem.append(productItemContainer);

//   // <div class="card...">
//   let card = document.createElement("div");
//   card.className = cardClasses.join(" ");
//   card.style.setProperty("--ratio-percent", `${ratioPercent}%`);
//   productItemContainer.append(card);

//   // Image

//   // <div class="product-card--image-container">
//   let productItemImageContainer = document.createElement("div");
//   productItemImageContainer.classList.add("product-card--image-container");
//   card.append(productItemImageContainer);

//   // <div>
//   let imageLinkWrapper = document.createElement("div");
//   productItemImageContainer.append(imageLinkWrapper);

//   // <a href="...">
//   let productItemImageLink = document.createElement("a");
//   // productItemImageLink.classList.add("productitem--image-link");
//   productItemImageLink.setAttribute("href", link);
//   // productItemImageLink.setAttribute("tabindex", -1);
//   // productItemImageLink.setAttribute("data-product-page-link", "");
//   // productItemImageLink.setAttribute('data-appmate','');
//   imageLinkWrapper.append(productItemImageLink);

//   // <div class="product-card--images">
//   let productItemImage = document.createElement("div");
//   productItemImage.classList.add("product-card--images");
//   // productItemImage.setAttribute("data-product-item-image", "");
//   imageLinkWrapper.append(productItemImage);

//   // <img ...>
//   let productImage = document.createElement("img");
//   productImage.onload = function () {
//     productImage.style.visibility = "visible";
//     productImage.nextElementSibling.style.visibility = "hidden";
//   };
//   productImage.setAttribute("src", imageUrl);
//   productImage.setAttribute("data-rimg", "lazy");
//   productImage.setAttribute("data-rimg-scale", 1);
//   productImage.setAttribute("data-rimg-template", imageUrlTemplate);
//   productImage.setAttribute("data-rimg-max", "185.5x185.5");
//   productImage.setAttribute("width", 185.5);
//   productImage.setAttribute("height", 185.5);
//   productImage.setAttribute("data-rimg-crop", false);
//   productImage.setAttribute("srcset", imageUrl);
//   productImage.setAttribute(
//     "data-rimg-template-svg",
//     `data:image/svg+xml;utf8,<svg%20xmlns='http://www.w3.org/2000/svg'%20width='512'%20height='636'></svg>`,
//   );
//   productItemImage.append(productImage);

//   let dataRimgCanvas = document.createElement("div");
//   dataRimgCanvas.setAttribute("data-rimg-canvas", "");
//   productItemImage.append(dataRimgCanvas);

//   // if (preOrder) {
//   //   let preOrderBadge = document.createElement("span");
//   //   preOrderBadge.innerHTML = `<span class="preorder-badge">Pre-Order</span>`;
//   //   productItemImage.append(preOrderBadge);
//   // }
//   // if (!inStock) {
//   //   let soldOutBadge = document.createElement("span");
//   //   soldOutBadge.innerHTML = `<span class="soldout-badge">Sold Out</span>`;
//   //   productItemImage.append(soldOutBadge);
//   // }

//   // <div class="product-card--button-container">
//   let productCardButtonContainer = document.createElement("div");
//   productCardButtonContainer.classList.add("product-card--button-container");
//   productItemImageContainer.append(productCardButtonContainer);

//   // <div class="quick-add no-js-hidden">
//   let quickAdd = document.createElement("div");
//   quickAdd.classList.add("quick-add", "no-js-hidden");
//   productCardButtonContainer.append(quickAdd);

//   // <button> - Use Klevu quick buy approach with full structure
//   let formId = `quick-add-${collection_section_id}-${product.id}`;
//   let submitId = `${formId}-submit`;
//   let titleId = `title-${collection_section_id}-${product.id}`;

//   const quickAddBtn = document.createElement("button");
//   quickAddBtn.id = submitId;
//   quickAddBtn.type = "button";
//   quickAddBtn.name = "add";
//   quickAddBtn.classList.add("quick-add__submit", "add-to-cart", "button", "button--full-width");
//   quickAddBtn.setAttribute("aria-haspopup", "dialog");
//   quickAddBtn.setAttribute("aria-labelledby", `${submitId} ${titleId}`);
//   quickAddBtn.setAttribute("aria-live", "polite");
//   quickAddBtn.setAttribute("data-sold-out-message", "true");

//   if (!inStock) {
//     quickAddBtn.classList.add("disabled");
//     quickAddBtn.setAttribute("disabled", "true");
//   } else {
//     quickAddBtn.setAttribute("data-variant-id", Number(product.variantid));

//     // Add click handler to add to cart via AJAX
//     quickAddBtn.addEventListener("click", function (e) {
//       e.preventDefault();
//       if (quickAddBtn.getAttribute("aria-disabled") === "true") return;

//       quickAddBtn.setAttribute("aria-disabled", "true");
//       const buttonText = quickAddBtn.querySelector("span");
//       const originalText = buttonText.textContent;
//       buttonText.textContent = "Adding...";

//       const cart =
//         document.querySelector("cart-notification") || document.querySelector("cart-drawer");
//       const formData = new FormData();
//       formData.append("id", product.variantid);
//       formData.append("quantity", 1);

//       if (cart) {
//         formData.append(
//           "sections",
//           cart.getSectionsToRender().map((section) => section.id),
//         );
//         formData.append("sections_url", window.location.pathname);
//         cart.setActiveElement(document.activeElement);
//       }

//       const config = fetchConfig("javascript");
//       config.headers["X-Requested-With"] = "XMLHttpRequest";
//       delete config.headers["Content-Type"];
//       config.body = formData;

//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             console.error("Error adding to cart:", response);
//             buttonText.textContent = originalText;
//             quickAddBtn.removeAttribute("aria-disabled");
//             return;
//           }

//           if (!cart) {
//             window.location = window.routes.cart_url;
//             return;
//           }

//           cart.renderContents(response);
//           buttonText.textContent = "Added!";
//           setTimeout(() => {
//             quickAddBtn.removeAttribute("aria-disabled");
//             buttonText.textContent = originalText;
//           }, 1500);
//         })
//         .catch((error) => {
//           console.error("Error:", error);
//           buttonText.textContent = originalText;
//           quickAddBtn.removeAttribute("aria-disabled");
//         });
//     });
//   }

//   // Determine button text based on stock and pre-order status
//   let buttonText;
//   if (!inStock) {
//     buttonText = window.productTexts.soldOut;
//     // } else if (preOrder) {
//     //   buttonText = window.productTexts.preOrder;
//   } else {
//     buttonText = window.productTexts.addToCart;
//   }

//   quickAddBtn.innerHTML = `
//     <span>${buttonText}</span>
//     <span class="sold-out-message hidden">${window.productTexts.soldOut}</span>
//   `;

//   quickAdd.append(quickAddBtn);

//   // Add Klevu quick buy settings script
//   let klevuQuickBuyScriptNew = document.createElement("script");
//   klevuQuickBuyScriptNew.setAttribute("type", "application/json");
//   klevuQuickBuyScriptNew.setAttribute("data-quick-buy-settings", "");
//   klevuQuickBuyScriptNew.innerHTML = `{
//     "cart_redirection": false,
//     "money_format": "${currencySymbol}{{amount}}"
//   }`;
//   li.append(klevuQuickBuyScriptNew);

//   // Add Klevu product tracking script
//   let klevuPLCollectionScriptNew = document.createElement("script");
//   klevuPLCollectionScriptNew.setAttribute("type", "text/javascript");
//   klevuPLCollectionScriptNew.innerHTML = `
//     if (typeof klevuProducts == 'undefined') {
//       var klevuProducts = new Array();
//     }
//     klevuProducts.push(${Number(product.id)});
//   `;
//   li.append(klevuPLCollectionScriptNew);

//   // <div class="has_wishlist">
//   if (window.cardConfig.showWishlistButton) {
//     let wishlistContainer = document.createElement("div");
//     wishlistContainer.classList.add("has_wishlist");

//     // <add-to-wishlist-button ...>
//     // Extract product handle from URL (e.g., "/products/some-product" -> "some-product")
//     const productHandle = product.url.split("/").pop();

//     let addToWishlistElement = document.createElement("add-to-wishlist-button");
//     addToWishlistElement.setAttribute("data-variant-id", product.variantid);
//     addToWishlistElement.setAttribute("data-product-id", product.id);
//     addToWishlistElement.setAttribute("data-product-handle", productHandle);
//     addToWishlistElement.setAttribute("data-wishlist-page", "0");

//     // <button ...>
//     let wishlistButton = document.createElement("button");
//     wishlistButton.classList.add(
//       "button",
//       "product-card__add-to-wishlist-button",
//       "button--full-width",
//     );
//     wishlistButton.type = "button";

//     // <span class="add-to-wishlist-button__text">
//     let wishlistButtonText = document.createElement("span");
//     wishlistButtonText.classList.add("add-to-wishlist-button__text");
//     wishlistButtonText.textContent = window.productTexts.addToWishlist;

//     wishlistButton.append(wishlistButtonText);
//     addToWishlistElement.append(wishlistButton);
//     wishlistContainer.append(addToWishlistElement);
//     productCardButtonContainer.append(wishlistContainer);
//   }

//   // <div class="card__department_icon_container ...">
//   const productTemplateSuffix = product.department; // Should work once Han's updated app
//   console.log("PRODUCT DEPT: ", product.department);
//   console.log("DEPT METAOBJECT: ", departmentMetaObject[productTemplateSuffix]);

//   if (productTemplateSuffix && departmentMetaObject[productTemplateSuffix]) {
//     const department = departmentMetaObject[productTemplateSuffix];
//     const badgeLayoutClass = window.cardConfig.badgeLayout || "badge_layout_stacked";

//     let cardDeptIconContainer = document.createElement("div");
//     cardDeptIconContainer.classList.add("card__department_icon_container", badgeLayoutClass);

//     let departmentIcon = document.createElement("img");

//     // Coloured Department Icon URL
//     if (product.departmentIconColour) {
//       // Colon is being replaced by space so the line below fixes this
//       const departmentIconColourFixUrl = product.departmentIconColour.replace(" ", ":");
//       departmentIcon.src = departmentIconColourFixUrl; // Should work once Han's updated app
//     }

//     if (product.departmentIconTransp) {
//       // Colon is being replaced by space so the line below fixes this
//       const departmentIconTranspFixUrl = product.departmentIconTransp.replace(" ", ":");
//     }

//     // Department Title
//     if (product.departmentTitle) {
//       departmentIcon.alt = product.departmentTitle; // Should work once Han's updated app
//     }

//     departmentIcon.classList.add("department_icon");
//     departmentIcon.loading = "lazy";

//     cardDeptIconContainer.append(departmentIcon);
//     productItemImageContainer.append(cardDeptIconContainer);
//   }

//   // <div class="card__content">
//   let cardContent = document.createElement("div");
//   cardContent.classList.add("card__content");
//   card.append(cardContent);

//   // <h3 class="text-body ...">
//   let cardTitle = document.createElement("h3");
//   cardTitle.classList.add("text-body", "card__heading", "underline-links-hover");
//   cardTitle.id = `title-${collection_section_id}`;
//   cardContent.append(cardTitle);

//   // <a id="CardLink-template--...">
//   let cardLink = document.createElement("a");
//   cardLink.id = `CardLink-${collection_section_id}`;
//   cardLink.classList.add("full-unstyled-link");
//   cardLink.setAttribute("href", link);
//   cardLink.setAttribute("aria-labelledby", `CardLink-${collection_section_id}`);
//   cardLink.innerText = product.name;
//   cardTitle.append(cardLink);

//   if (product.artist) {
//     // <h4 class="text-body card__artist">
//     let cardArtist = document.createElement("h4");
//     cardArtist.classList.add("text-body", "card__artist");
//     cardArtist.innerText = product.artist;
//     cardContent.append(cardArtist);
//   }

//   // <span>{{ item.type }}</span>
//   let productItemType = document.createElement("span");
//   productItemType.textContent = product.type;
//   cardContent.append(productItemType);

//   // <div class="card-price-information">
//   let cardPriceInfo = document.createElement("div");
//   cardPriceInfo.classList.add("card-price-information");
//   cardContent.append(cardPriceInfo);

//   // <span class="discount_percentage ...">
//   // Sale badge - matches sale-badge.liquid logic
//   if (onSale && inStock && discount >= window.cardConfig.saleBadgeThreshold) {
//     let saleBadge = document.createElement("span");
//     saleBadge.classList.add("discount_percentage");
//     saleBadge.style.color = `rgb(var(${window.cardConfig.saleBadgeFg}))`;
//     saleBadge.style.backgroundColor = `rgb(var(${window.cardConfig.saleBadgeBg}))`;
//     saleBadge.textContent = `${window.productTexts.saleBadgeText} ${discount}%`;
//     cardPriceInfo.append(saleBadge);
//   }

//   // <div class="price"> / <div class="price price--on-sale">
//   let cardPriceWrapper = document.createElement("div");

//   if (onSale) {
//     cardPriceWrapper.classList.add("price", "price--on-sale");
//   } else {
//     cardPriceWrapper.classList.add("price");
//   }

//   cardPriceInfo.append(cardPriceWrapper);

//   // <div class="price__container">
//   let cardPriceContainer = document.createElement("div");
//   cardPriceContainer.classList.add("price__container");
//   cardPriceWrapper.append(cardPriceContainer);

//   // <div class="price__regular"> - Displayed when there are no variants on sale
//   let priceRegular = document.createElement("div");
//   priceRegular.classList.add("price__regular");
//   cardPriceContainer.append(priceRegular);

//   // <span class="visually-hidden visually-hidden--inline">Regular price</span>
//   let regularPriceLabel = document.createElement("span");
//   regularPriceLabel.classList.add("visually-hidden", "visually-hidden--inline");
//   regularPriceLabel.textContent = "Regular price";
//   priceRegular.append(regularPriceLabel);

//   // <span class="price-item price-item--regular">£X.XX</span>
//   let regularPriceValue = document.createElement("span");
//   regularPriceValue.classList.add("price-item", "price-item--regular");
//   // regularPriceValue.textContent = `£${price.toFixed(2)}`;
//   if (changeCurrency && priceData[product.id]) {
//     regularPriceValue.textContent = priceData[product.id].price;
//   } else {
//     regularPriceValue.textContent = `£${price.toFixed(2)}`;
//   }
//   priceRegular.append(regularPriceValue);

//   // <div class="price__sale"> - Displayed when a variant is on sale
//   let priceSale = document.createElement("div");
//   priceSale.classList.add("price__sale");
//   cardPriceContainer.append(priceSale);

//   // <span class="visually-hidden visually-hidden--inline">Regular price</span>
//   let salePriceRegularLabel = document.createElement("span");
//   salePriceRegularLabel.classList.add("visually-hidden", "visually-hidden--inline");
//   salePriceRegularLabel.textContent = "Regular price";
//   priceSale.append(salePriceRegularLabel);

//   // <span><s class="price-item price-item--regular">£X.XX</s></span>
//   let salePriceCompareWrapper = document.createElement("span");
//   priceSale.append(salePriceCompareWrapper);

//   let salePriceCompare = document.createElement("s");
//   salePriceCompare.classList.add("price-item", "price-item--regular");
//   // salePriceCompare.textContent = `£${comparePrice.toFixed(2)}`;
//   if (changeCurrency && priceData[product.id]) {
//     salePriceCompare.textContent = priceData[product.id].comparePrice;
//   } else {
//     salePriceCompare.textContent = `£${comparePrice.toFixed(2)}`;
//   }
//   salePriceCompareWrapper.append(salePriceCompare);

//   // <span class="visually-hidden visually-hidden--inline">Sale price</span>
//   let salePriceLabel = document.createElement("span");
//   salePriceLabel.classList.add("visually-hidden", "visually-hidden--inline");
//   salePriceLabel.textContent = "Sale price";
//   priceSale.append(salePriceLabel);

//   // <span class="price-item price-item--sale price-item--last">£X.XX</span>
//   let salePriceValue = document.createElement("span");
//   salePriceValue.classList.add("price-item", "price-item--sale", "price-item--last");
//   // salePriceValue.textContent = `£${price.toFixed(2)}`;
//   if (changeCurrency && priceData[product.id]) {
//     salePriceValue.textContent = priceData[product.id].price;
//   } else {
//     salePriceValue.textContent = `£${price.toFixed(2)}`;
//   }
//   priceSale.append(salePriceValue);

//   // Product badges - matches product-badges.liquid logic

//   const badgeKey = product.badgeKey; // Should work once Han's updated app

//   if (!inStock && window.cardConfig.showSoldOutBadge) {
//     // Sold out badge
//     const badgeFormat = window.cardConfig.badgeFormat || "right-small";

//     let soldOutBadge = document.createElement("span");
//     soldOutBadge.classList.add(
//       "badge",
//       "badge-sold-out",
//       "price__badge-sold-out",
//       `badge-format-${badgeFormat}`,
//     );
//     soldOutBadge.textContent = window.productTexts.soldOut;
//     // const badgeKey = product.badgeKey; // Should work once Han's updated app

//     cardContent.append(soldOutBadge);
//   } else if (badgeKey) {
//     // const productBadge = product.badgeData[badgeKey];
//     // Should work once Han's updated app:
//     // if (badgeKey && badgeMetaObject[badgeKey]) {
//     //   const productBadge = badgeMetaObject[badgeKey];
//     // console.log("PRODUCT BADGE: ", productBadge);
//     // Custom badge from metaobject
//     // console.log("BADGE KEY: ", badgeKey);
//     const badgeFormat = window.cardConfig.badgeFormat || "right-small";

//     // Create badge element (either <a> or <span> depending on if there's a link)
//     let badgeElement;
//     if (product.badgeCollectionLink) {
//       badgeElement = document.createElement("a");
//       badgeElement.href = product.badgeCollectionLink;
//     } else {
//       badgeElement = document.createElement("span");
//     }

//     badgeElement.classList.add(
//       "badge",
//       "badge-custom",
//       "product_badge",
//       `badge-format-${badgeFormat}`,
//     );

//     if (product.badgeTagBackgroundColour && product.badgeTagTextColour) {
//       let badgeStyles = `--colour-custom-badge-background: ${product.badgeTagBackgroundColour}; color: ${product.badgeTagTextColour}`;
//       badgeElement.style.cssText = badgeStyles;
//     }

//     // <span class="badge-text">
//     if (product.badgeTagText) {
//       let badgeText = document.createElement("span");
//       badgeText.classList.add("badge-text");
//       badgeText.textContent = product.badgeTagText; // Should work once Han's updated app
//       badgeElement.append(badgeText);
//       cardContent.append(badgeElement);
//     }
//   }

//   /** info */

//   // let productItemInfo = document.createElement("div");
//   // productItemInfo.classList.add("productitem--info");
//   // card.append(productItemInfo);

//   // let productItemPriceContainer = document.createElement("div");
//   // productItemPriceContainer.classList.add("price", "productitem__price");
//   // productItemInfo.append(productItemPriceContainer);

//   // let compareAtPrice = document.createElement("div");
//   // compareAtPrice.classList.add("price__compare-at", "visible");
//   // compareAtPrice.setAttribute("data-price-compare-container", "");
//   // productItemPriceContainer.append(compareAtPrice);

//   // let compareAtPriceSpan = document.createElement("span");
//   // compareAtPriceSpan.classList.add("money", "price__original");
//   // compareAtPriceSpan.setAttribute("data-price-original", "");
//   // if (onSale)
//   //   compareAtPriceSpan.innerText = changeCurrency
//   //     ? priceData[product.id]?.comparePrice
//   //     : `£${comparePrice.toFixed(2)}`;
//   // compareAtPrice.append(compareAtPriceSpan);

//   // let priceElem = document.createElement("div");
//   // priceElem.classList.add("price__current", "price__current--emphasize");
//   // priceElem.setAttribute("data-price-container", "");
//   // productItemPriceContainer.append(priceElem);

//   // let priceSpan = document.createElement("span");
//   // priceSpan.classList.add("money");
//   // priceSpan.setAttribute("data-price", "");
//   // priceSpan.innerText = changeCurrency ? priceData[product.id]?.price : `£${price.toFixed(2)}`;
//   // priceElem.append(priceSpan);

//   // let productItemType = document.createElement("div");
//   // productItemType.classList.add("wrap_");
//   // productItemType.innerText = product.type;
//   // productItemInfo.append(productItemType);

//   // let productItemTitle = document.createElement("h2");
//   // productItemTitle.classList.add("productitem--title");
//   // productItemInfo.append(productItemTitle);

//   // let productItemTitleLink = document.createElement("a");
//   // productItemTitleLink.setAttribute("href", link);
//   // productItemTitleLink.setAttribute("data-product-page-link", "");
//   // productItemTitleLink.innerText = product.name;
//   // productItemTitle.append(productItemTitleLink);

//   // if (product.artist && product.artist != "") {
//   //   let highlightMetafield = document.createElement("div");
//   //   highlightMetafield.classList.add("metafield_");
//   //   // quick fix for metafield
//   //   if (product.artist.startsWith("[") && product.artist.endsWith("]")) {
//   //     highlightMetafield.innerText = product.artist.slice(1, product.artist.length - 1);
//   //   } else {
//   //     highlightMetafield.innerText = product.artist;
//   //   }
//   //   productItemInfo.append(highlightMetafield);
//   // }

//   // let productItemStockLevel = document.createElement("div");
//   // productItemStockLevel.classList.add("productitem__stock-level");
//   // productItemInfo.append(productItemStockLevel);

//   // let productItemStockLevelWrapper = document.createElement("div");
//   // productItemStockLevelWrapper.classList.add("product-stock-level-wrapper");
//   // productItemStockLevel.append(productItemStockLevelWrapper);

//   // if (product.inventoryQuantity && inStock) {
//   //   let stockLevelNumber = Number(product.inventoryQuantity);
//   //   let stockLevelClassName = "product-stock-level--high",
//   //     stockLevelText = "Available";
//   //   if (stockLevelNumber < 5) {
//   //     stockLevelClassName = "product-stock-level--low";
//   //     stockLevelText = "Low stock";
//   //   }
//   //   let productItemStockLevelSpan = document.createElement("span");
//   //   productItemStockLevelSpan.classList.add("product-stock-levels", stockLevelClassName);
//   //   productItemStockLevelSpan.innerHTML = `<span class="product-stock-level__text"><div class="product-stock-level__badge-text">${stockLevelText}</div></span>`;
//   //   productItemStockLevelWrapper.append(productItemStockLevelSpan);
//   // }

//   // let productItemDescrition = document.createElement("div");
//   // productItemDescrition.classList.add("productitem--description");
//   // productItemInfo.append(productItemDescrition);

//   // if (product.shortDesc) {
//   //   let descriptionPara = document.createElement("p");
//   //   descriptionPara.innerText = product.shortDesc;
//   //   productItemDescrition.append(descriptionPara);
//   // }

//   // let descriptionLink = document.createElement("a");
//   // descriptionLink.classList.add("productitem--link");
//   // descriptionLink.setAttribute("data-product-page-link", "");
//   // descriptionLink.setAttribute("href", link);
//   // descriptionLink.innerText = "View full details";
//   // productItemDescrition.append(descriptionLink);

//   // let productItemActions = document.createElement("div");
//   // productItemActions.classList.add("productitem--actions");
//   // productItemActions.setAttribute("data-product-actions", "");
//   // card.append(productItemActions);

//   // let productItemListViewPrice = document.createElement("div");
//   // productItemListViewPrice.classList.add("productitem--listview-price");
//   // productItemActions.append(productItemListViewPrice);

//   // let productItemListViewPriceInner = productItemPriceContainer.cloneNode(true);
//   // productItemListViewPrice.append(productItemListViewPriceInner);

//   // if (onSale && inStock) {
//   //   let productItemListViewBadge = document.createElement("div");
//   //   productItemListViewBadge.classList.add("productitem--listview-badge");
//   //   productItemActions.append(productItemListViewBadge);

//   //   let productItemListViewBadgeInner = productItemSaleBadge.cloneNode(true);
//   //   productItemListViewBadge.append(productItemListViewBadgeInner);
//   // }

//   // let productATCButton = document.createElement("div");
//   // productATCButton.classList.add("productitem--action", "atc--button");
//   // productItemActions.append(productATCButton);

//   // let productButton = document.createElement("button");
//   // let productButtonText = preOrder ? "Pre-Order" : "Add to basket";
//   // productButton.classList.add(
//   //   "productitem--action-trigger",
//   //   "productitem--action-atc",
//   //   "button-primary",
//   //   "mdc-ripple-surface",
//   //   "mdc-ripple-upgraded",
//   // );
//   // productButton.setAttribute("type", "button");
//   // if (!inStock) {
//   //   productButtonText = "Sold Out";
//   //   productButton.classList.add("disabled");
//   //   productButton.setAttribute("disabled", "true");
//   // } else {
//   //   if (preOrder) productButton.classList.add("preorder-button");
//   //   productButton.setAttribute("data-quick-buy", "");
//   //   productButton.setAttribute("data-variant-id", Number(product.variantid));
//   // }

//   // productButton.setAttribute("aria-label", productButtonText);
//   // productButton.addEventListener("click", (e) => {
//   //   console.log("click");
//   // });
//   // productButton.innerHTML = `<span class=\"atc-button--text\">${productButtonText}</span>`;
//   // if (inStock) {
//   //   productButton.innerHTML += `<span class=\"atc-button--icon\"><svg aria-hidden=\"true\" focusable=\"false\" role=\"presentation\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g fill-rule=\"nonzero\" fill=\"currentColor\">\n    <path d=\"M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z\" opacity=\".29\"></path><path d=\"M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z\"></path>\n  </g>\n</svg></span>`;
//   // }
//   // productATCButton.append(productButton);

//   /** create */
//   product_grid_ul.append(li);
//   // product_items.push(new ProductGridItem({
//   //     el: li,
//   //     id: collection_section_id,
//   //     lazy: true,
//   //     grid_list: view
//   // }));
// }

// function buildPagination(totalResultsFound) {
//   let numberOfPages = Math.ceil(totalResultsFound / limit);
//   if (numberOfPages > 1) {
//     for (let pageCounter = 1; pageCounter <= numberOfPages; pageCounter++) {
//       let paginationLi = document.createElement("li");
//       let paginationAnchor = document.createElement("a");
//       paginationLi.append(paginationAnchor);
//       if (
//         pageCounter === 1 ||
//         (pageCounter >= page - 2 && pageCounter <= page + 2) ||
//         pageCounter === numberOfPages
//       ) {
//         if (pageCounter === page) {
//           paginationAnchor.classList.add("pagination__item--current", "light");
//           paginationAnchor.setAttribute("aria-label", `Page ${pageCounter}`);
//           paginationAnchor.setAttribute("aria-current", true);
//           paginationAnchor.setAttribute("aria-disabled", true);
//           paginationAnchor.innerText = pageCounter;
//         } else {
//           paginationAnchor.setAttribute("href", buildHref(pageCounter));
//           paginationAnchor.removeAttribute("aria-disabled");
//         }
//         paginationAnchor.classList.add("pagination--item", "pagination__item");
//         paginationAnchor.innerText = pageCounter;
//         paginationList.insertBefore(paginationLi, pagination_next);
//       } else if (pageCounter < page - 2 && !hasEllipsisBefore) {
//         addEllipsis(true);
//       } else if (pageCounter > page + 2 && !hasEllipsisAfter) {
//         addEllipsis(false);
//       }
//     }

//     if (page === 1) {
//       pagination_previous.style.display = "none";
//     } else {
//       pagination_previous
//         .querySelector(".pagination--item")
//         .setAttribute("href", buildHref(page - 1));
//     }

//     if (page === numberOfPages) {
//       pagination_next.style.display = "none";
//     } else {
//       pagination_next.querySelector(".pagination--item").setAttribute("href", buildHref(page + 1));
//     }
//   } else {
//     pagination_container.style.opacity = 0;
//   }
// }

// function addEllipsis(before) {
//   let paginationLi = document.createElement("li");

//   paginationLi.classList.add("pagination--ellipsis");
//   let paginationItem = document.createElement("span");
//   paginationItem.classList.add("pagination--item", "pagination__item");
//   paginationItem.innerText = "...";
//   paginationLi.append(paginationItem);
//   paginationList.insertBefore(paginationLi, pagination_next);
//   before ? (hasEllipsisBefore = true) : (hasEllipsisAfter = true);
// }

// function setShowValue() {
//   show_by_items.forEach((item) => {
//     if (Number(item.getAttribute("data-show-by")) === limit) {
//       item.classList.add("utils-showby-item--active");
//     } else {
//       item.classList.remove("utils-showby-item--active");
//     }
//     if (currentFilters.length > 0) {
//       let params = new URLSearchParams();
//       currentFilters.forEach((filter) => {
//         params.append("filter", filter);
//       });
//       item.setAttribute("href", `${item.getAttribute("href")}&${params.toString()}`);
//     }
//   });
// }

/** filter functions */

// function buildFilterBlock(filter, index) {
//   let lastSelectedFilterKey = lastInteraction != undefined ? lastInteraction : null;
//   let tmpCachedFilters = null;

//   const config = window.facetConfig;
//   const texts = window.facetTexts;
//   const sectionId = config.sectionId;

//   // Count active values for this filter
//   let activeValuesCount = 0;
//   currentFilters.forEach((currentFilter) => {
//     let filterArray = currentFilter.split("_");
//     let filterKey = filterArray[0];
//     if (filterKey === filter.key) {
//       activeValuesCount++;
//     }
//   });

//   // Determine if this filter should be open
//   let isOpen = (config.filterType === "vertical" && index === 0) || activeValuesCount > 0;

//   // <details>
//   let details = document.createElement("details");
//   details.id = `Details-${filter.key}-${sectionId}`;
//   details.className = config.classes.facetDisclosure;
//   details.setAttribute("data-index", index + 1);
//   if (isOpen) {
//     details.setAttribute("open", "");
//   }

//   const facetsWrapperDesktop = document.querySelector("#FacetsWrapperDesktop");
//   if (facetsWrapperDesktop) {
//     facetsWrapperDesktop.append(details);
//   }

//   // <summary>
//   let summary = document.createElement("summary");
//   summary.className = config.classes.facetSummary;
//   summary.setAttribute(
//     "aria-label",
//     `${filter.label} (${texts.filtersSelected.replace("1", activeValuesCount)})`,
//   );

//   let summaryDiv = document.createElement("div");
//   let summaryLabel = document.createElement("span");
//   summaryLabel.className = "facets__summary-label";
//   summaryLabel.textContent = filter.label === "klevu_price" ? "Price" : filter.label;

//   // Add active count for vertical layout
//   if (config.filterType === "vertical") {
//     let selectedSpan = document.createElement("span");
//     selectedSpan.className = `facets__selected${activeValuesCount === 0 ? " hidden" : ""}`;
//     selectedSpan.textContent = ` (${activeValuesCount})`;
//     summaryLabel.append(selectedSpan);
//   }

//   summaryDiv.append(summaryLabel);

//   // // Add chevron icon
//   let iconSpan = document.createElement("span");
//   iconSpan.innerHTML = config.icons.chevronDown;
//   summaryDiv.append(iconSpan);

//   summary.append(summaryDiv);
//   details.append(summary);

//   // Create content div (replaces the old filterGroupList)
//   let contentDiv = document.createElement("div");
//   contentDiv.id = `Facet-${index + 1}-${sectionId}`;
//   contentDiv.className = config.classes.facetDisplay;
//   details.appendChild(contentDiv);

//   // Handle price range filter
//   if (filter.key === "klevu_price") {
//     tmpCachedFilters = filter;

//     // Add header with max price info
//     let headerDiv = document.createElement("div");
//     headerDiv.className = config.classes.facetsHeader;
//     let maxPriceP = document.createElement("p");
//     maxPriceP.className = "mobile-facets__info";

//     let filterMin = changeCurrency ? Number(filterMinMaxData.min) : Number(filter.min);
//     let filterMax = changeCurrency ? Number(filterMinMaxData.max) : Number(filter.max);

//     // Format max price
//     let maxPriceFormatted = `${currencySymbol}${filterMax.toFixed(2)}`;
//     maxPriceP.textContent = texts.maxPrice.replace("[PRICE]", maxPriceFormatted);
//     headerDiv.appendChild(maxPriceP);
//     contentDiv.appendChild(headerDiv);

//     // Create price-range-slider wrapper
//     let priceRangeSlider = document.createElement("price-range-slider");
//     contentDiv.appendChild(priceRangeSlider);

//     // Create price slider container
//     priceSliderContainer = document.createElement("div");
//     priceSliderContainer.classList.add("etempa-price-slider-container");
//     priceRangeSlider.appendChild(priceSliderContainer);

//     let priceFilter = document.createElement("input");
//     priceFilter.setAttribute("id", "etempa-filter-price-slider");
//     priceFilter.classList.add("etempa-filter-price-slider");
//     priceSliderContainer.appendChild(priceFilter);

//     if (filterMax <= 50) {
//       step = 10;
//     } else if (filterMax <= 150) {
//       step = 20;
//     } else {
//       step = 50;
//     }

//     let minPrice = Math.floor(filterMin / step) * step;
//     let maxPrice = Math.ceil(filterMax / step) * step;
//     priceRange = [];

//     for (let price = minPrice; price <= maxPrice; price += step) {
//       priceRange.push(price);
//     }

//     buildPriceSlider();
//   } else {
//     // Handle list/boolean filters
//     let enabledFilterOptions = [...filter.options];
//     if (lastSelectedFilterKey == filter.key) {
//       let cachedEnabledFilter = cachedFilters.filters?.find((f) => f.key == filter.key);
//       if (cachedEnabledFilter) {
//         enabledFilterOptions = [...cachedEnabledFilter.options];
//         tmpCachedFilters = cachedEnabledFilter;
//       } else {
//         enabledFilterOptions = [...filter.options];
//         tmpCachedFilters = filter;
//       }
//     } else {
//       tmpCachedFilters = filter;
//     }

//     //check to see if there are any 'enabled' filters that aren't returned by Klevu
//     let enabledFiltersNotInDataset = [];
//     currentFilters.forEach((currentFilter) => {
//       let filterArray = currentFilter.split("_");
//       let filterKey = filterArray[0];
//       let filterValue = decodeURIComponent(filterArray[1]);
//       if (filterKey == filter.key) {
//         if (enabledFilterOptions.find((f) => f.value === filterValue) === undefined) {
//           enabledFiltersNotInDataset.push({ value: filterValue });
//         }
//       }
//     });
//     enabledFilterOptions.push(...enabledFiltersNotInDataset);

//     if (
//       enabledFilterOptions &&
//       Array.isArray(enabledFilterOptions) &&
//       enabledFilterOptions.length > 0
//     ) {
//       // Create fieldset wrapper (matches facets-new.liquid structure)
//       let fieldset = document.createElement("fieldset");
//       fieldset.className = config.classes.facetsWrap;

//       let legend = document.createElement("legend");
//       legend.className = "visually-hidden";
//       legend.textContent = filter.label;
//       fieldset.appendChild(legend);

//       // Create ul list (matches facets-new.liquid structure)
//       let ul = document.createElement("ul");
//       ul.className = config.classes.facetsList;
//       ul.setAttribute("role", "list");
//       fieldset.appendChild(ul);

//       contentDiv.appendChild(fieldset);

//       // Limit filters
//       let loopLimit = enabledFilterOptions.length;

//       if (enabledFilterOptions.length > 25) {
//         loopLimit = 25;

//         let filterOptionSearch = document.createElement("input");
//         filterOptionSearch.setAttribute("type", "text");
//         filterOptionSearch.classList.add("facet-filters__search");
//         filterOptionSearch.setAttribute("data-filter-key", filter.key);
//         filterOptionSearch.setAttribute("placeholder", "Search...");
//         filterOptionSearch.addEventListener("keyup", filterOptionSearchChange);

//         let searchResultsContainer = document.createElement("div");
//         searchResultsContainer.classList.add("facet-filters__search-results");
//         searchResultsContainer.style.display = "none";

//         contentDiv.insertBefore(filterOptionSearch, fieldset);
//         contentDiv.insertBefore(searchResultsContainer, fieldset);

//         fieldset.classList.add("facet-filters__main-options");
//       }

//       // Populate filter options
//       for (let optionIndex = 0; optionIndex < loopLimit; optionIndex++) {
//         let option = enabledFilterOptions[optionIndex];
//         let isActive = currentFilters.includes(`${filter.key}_${encodeURIComponent(option.value)}`);

//         // Create li element
//         let li = document.createElement("li");
//         li.className = config.classes.facetsItem;

//         // Limit number of filters visible
//         if (optionIndex >= config.showMoreNumber && config.filterType === "vertical") {
//           li.className += ` ${config.classes.showMoreItem}`;
//         }

//         // Create label
//         let label = document.createElement("label");
//         label.setAttribute("for", `Filter-${filter.key}-${optionIndex}`);
//         label.className = `${config.classes.facetsLabel}${isActive ? " active" : ""}`;

//         // Create checkbox input
//         let input = document.createElement("input");
//         input.type = "checkbox";
//         input.name = filter.key;
//         input.value = option.value;
//         input.id = `Filter-${filter.key}-${optionIndex}`;
//         if (isActive) {
//           input.checked = true;
//         }
//         input.addEventListener("change", function () {
//           filterOptionChange(filter.key, option.value, this.checked);
//         });

//         label.appendChild(input);

//         // Add mobile highlight and square (matches facets-new.liquid)
//         let highlight = document.createElement("span");
//         highlight.className = config.classes.mobileHighlight;
//         label.appendChild(highlight);

//         let square = document.createElement("span");
//         square.className = config.classes.mobileSquare;
//         label.appendChild(square);

//         // Add checkmark icon
//         let checkmarkSpan = document.createElement("span");
//         checkmarkSpan.innerHTML = config.icons.checkmark;
//         label.appendChild(checkmarkSpan);

//         // Add text value
//         let textSpan = document.createElement("span");
//         textSpan.className = "facet-checkbox__text";
//         textSpan.setAttribute("aria-hidden", "true");

//         let textLabel = document.createElement("span");
//         textLabel.className = "facet-checkbox__text-label";
//         textLabel.textContent = option.value;
//         textSpan.appendChild(textLabel);

//         label.appendChild(textSpan);

//         // Add visually hidden count (if available)
//         if (option.count !== undefined) {
//           let hiddenSpan = document.createElement("span");
//           hiddenSpan.className = "visually-hidden";
//           hiddenSpan.textContent = ` (${option.count})`;
//           label.appendChild(hiddenSpan);
//         }

//         li.appendChild(label);
//         ul.appendChild(li);
//       }
//       // Show more
//       if (enabledFilterOptions.length > config.showMoreNumber && config.filterType === "vertical") {
//         let showMoreButton = document.createElement("show-more-button");
//         let button = document.createElement("button");
//         button.className = "button-show-more link underlined-link";
//         button.type = "button";
//         button.id = `Show-More-${index + 1}-${sectionId}`;

//         let showMoreSpan = document.createElement("span");
//         showMoreSpan.className = "label-show-more label-text";
//         showMoreSpan.innerHTML = `<span aria-hidden="true">+ ${texts.showMore}</span>`;

//         let showLessSpan = document.createElement("span");
//         showLessSpan.className = "label-show-less label-text hidden";
//         showLessSpan.innerHTML = `<span aria-hidden="true">- ${texts.showLess}</span>`;

//         button.appendChild(showMoreSpan);
//         button.appendChild(showLessSpan);
//         showMoreButton.appendChild(button);
//         contentDiv.appendChild(showMoreButton);

//         button.addEventListener("click", (e) => {
//           e.preventDefault();
//           e.stopPropagation();

//           const parentDisplay = e.currentTarget.closest(".parent-display");

//           if (parentDisplay) {
//             showMoreSpan.classList.toggle("hidden");
//             showLessSpan.classList.toggle("hidden");

//             parentDisplay.querySelectorAll(".show-more-item").forEach((item) => {
//               item.classList.toggle("hidden");
//             });
//           }
//         });
//       }
//     }
//   }

//   const facetsWrapperMobile = document.querySelector("#FacetsWrapperMobile");
//   if (facetsWrapperMobile) {
//     const detailsMobile = details.cloneNode(true);

//     // Re-attach event listeners to cloned checkboxes
//     const mobileCheckboxes = detailsMobile.querySelectorAll('input[type="checkbox"]');
//     mobileCheckboxes.forEach((checkbox) => {
//       const filterKey = checkbox.name;
//       const filterValue = checkbox.value;
//       checkbox.addEventListener("change", function () {
//         filterOptionChange(filterKey, filterValue, this.checked);
//       });
//     });

//     // Re-attach event listener to search input if it exists
//     const mobileSearchInput = detailsMobile.querySelector(".facet-filters__search");
//     if (mobileSearchInput) {
//       mobileSearchInput.addEventListener("keyup", filterOptionSearchChange);
//     }

//     // Re-attach event listener to show more button if it exists
//     const mobileShowMoreButton = detailsMobile.querySelector(".button-show-more");
//     if (mobileShowMoreButton) {
//       const showMoreSpan = mobileShowMoreButton.querySelector(".label-show-more");
//       const showLessSpan = mobileShowMoreButton.querySelector(".label-show-less");

//       mobileShowMoreButton.addEventListener("click", (e) => {
//         e.preventDefault();
//         e.stopPropagation();

//         const parentDisplay = e.currentTarget.closest(".parent-display");

//         if (parentDisplay) {
//           showMoreSpan.classList.toggle("hidden");
//           showLessSpan.classList.toggle("hidden");

//           parentDisplay.querySelectorAll(".show-more-item").forEach((item) => {
//             item.classList.toggle("hidden");
//           });
//         }
//       });
//     }

//     facetsWrapperMobile.append(detailsMobile);
//   }

//   return tmpCachedFilters;
// }

// New filter option change handler (for checkbox inputs)
// function filterOptionChange(filterKey, filterValue, isChecked) {
//   if (window.innerWidth < 860) showLoadingSpinner();

//   let target = `${filterKey}_${encodeURIComponent(filterValue)}`;

//   if (isChecked) {
//     // Add filter
//     if (!currentFilters.includes(target)) {
//       currentFilters.push(target);
//     }
//   } else {
//     // Remove filter
//     currentFilters = currentFilters.filter((item) => item !== target);
//   }

//   localStorage.setItem("klevuCollectionCachedInteraction", filterKey);
//   window.location.href = buildHref(1);
// }

// Old functions - keeping for backward compatibility if needed elsewhere
// function populateOptions(filterKey, optionValue, filterOptionsContainer) {
//   let activeFilter = currentFilters.includes(`${filterKey}_${encodeURIComponent(optionValue)}`)
//     ? true
//     : false;
//   let filterOption = document.createElement("li");
//   filterOption.classList.add("collection-filters__filter-list-item");
//   if (activeFilter) filterOption.classList.add("collection-filters__filter-list-item--active");
//   filterOption.setAttribute("data-filter-open", activeFilter);
//   filterOption.setAttribute("data-filter-key", filterKey);
//   filterOption.setAttribute("data-filter-value", optionValue);
//   filterOption.addEventListener("click", filterOptionClick);
//   filterOptionsContainer.append(filterOption);

//   let filterOptionLink = document.createElement("a");
//   filterOptionLink.classList.add("collection-filters__filter-link");
//   filterOptionLink.setAttribute("data-filter-input", "");
//   if (activeFilter) filterOptionLink.setAttribute("data-filter-active", "");
//   filterOptionLink.innerHTML = `<span class="filter-icon--checkbox" data-handle="filter-Product-type-0">`;
//   filterOptionLink.innerHTML += `<svg class="checkmark" aria-hidden="true" focusable="false" role="presentation" width="14" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" data-animation-state="${activeFilter ? "checked" : "unchecked"}"><path class="checkmark__check" fill="none" d="M2.5 7L5.5 10L11.5 4" data-animation-state="${activeFilter ? "checked" : "unchecked"}"></path>`;
//   filterOptionLink.innerHTML += `</svg></span> <span class="collection-filters__filter-list-item-text">${optionValue}</span>`;
//   filterOption.append(filterOptionLink);
// }

// function filterGroupButtonClick() {
//   let _thisul = this.parentElement.querySelector(".collection-filters__filter-list");
//   if (this.classList.contains("productgrid--sidebar-button-active")) {
//     this.classList.remove("productgrid--sidebar-button-active");
//     _thisul.classList.remove("filter-group-active");
//     _thisul.style.height = 0;
//   } else {
//     this.classList.add("productgrid--sidebar-button-active");
//     this.setAttribute("aria-expanded", true);
//     _thisul.classList.add("filter-group-active");
//     let height = getHiddenHeight(_thisul);
//     if (height < 1) {
//       _thisul.style.height = `auto`;
//     } else {
//       _thisul.style.height = `${getHiddenHeight(_thisul)}px`;
//     }
//   }
// }

// function filterOptionClick(e) {
//   e.preventDefault();
//   // prevent selection of multiple filters at the same time
//   // if (filter_form.classList.contains("loading")) return;
//   // filter_form.classList.add("loading");
//   if (window.innerWidth < 860) showLoadingSpinner();
//   let _thislink = this.querySelector(".collection-filters__filter-link");
//   let _thissvg = _thislink.querySelector(".checkmark");
//   let _thispath = _thislink.querySelector(".checkmark__check");
//   let filterKey = this.getAttribute("data-filter-key");
//   let filterValue = this.getAttribute("data-filter-value");
//   if (this.classList.contains("collection-filters__filter-list-item--active")) {
//     this.classList.remove("collection-filters__filter-list-item--active");
//     this.setAttribute("data-filter-open", false);
//     _thislink.removeAttribute("data-filter-active", "");
//     _thissvg.setAttribute("data-animation-state", "unchecked");
//     _thispath.setAttribute("data-animation-state", "unchecked");
//     let target = `${filterKey}_${encodeURIComponent(filterValue)}`;
//     currentFilters = currentFilters.filter((item) => item !== target);
//   } else {
//     this.classList.add("collection-filters__filter-list-item--active");
//     this.setAttribute("data-filter-open", true);
//     _thislink.setAttribute("data-filter-active", "");
//     _thissvg.setAttribute("data-animation-state", "checked");
//     _thispath.setAttribute("data-animation-state", "checked");
//     currentFilters.push(`${filterKey}_${encodeURIComponent(filterValue)}`);
//   }
//   // console.log(currentFilters);
//   localStorage.setItem("klevuCollectionCachedInteraction", filterKey);
//   window.location.href = buildHref(1);
// }
// End old functions

// function showLoadingSpinner() {
//   let spinnerContainer = document.createElement("div");
//   spinnerContainer.classList.add("mobile-modal-spinner");
//   spinnerContainer.style.position = "fixed";
//   spinnerContainer.style.width = "100%";
//   spinnerContainer.style.height = "100vh";
//   spinnerContainer.style.top = 0;
//   spinnerContainer.style.left = 0;
//   spinnerContainer.style.display = "grid";
//   spinnerContainer.style.backgroundColor = "rgba(255,255,255,0.8)";
//   spinnerContainer.style.placeItems = "center";
//   spinnerContainer.style.zIndex = 999;
//   spinnerContainer.innerHTML = `<?xml version="1.0" encoding="utf-8"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="104px" height="104px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="#e5342e" stroke-width="1" r="35" stroke-dasharray="164.93361431346415 56.97787143782138"> <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>`;

//   document.querySelector("body").appendChild(spinnerContainer);
// }

// function buildPriceSlider() {
//   // Check if rSlider is available
//   if (typeof rSlider === "undefined") {
//     console.warn("rSlider library not loaded. Price slider will not be available.");
//     return;
//   }

//   sliderInteraction = false; // Reset on build - prevents onChange from triggering page reload

//   // Check if there's an existing price filter to preserve
//   let existingPriceFilter = currentFilters.find((f) => f.includes("minMaxPrice"));
//   let setValues = null;

//   if (existingPriceFilter) {
//     let parts = existingPriceFilter.split("_");
//     if (parts.length === 3) {
//       setValues = [Number(parts[1]), Number(parts[2])];
//     }
//   }

//   priceSlider = new rSlider({
//     target: "#etempa-filter-price-slider",
//     values: priceRange,
//     range: true, // range slider
//     set: setValues, // preserve existing price filter if any
//     width: priceSliderContainer.getBoundingClientRect().width - 30,
//     scale: true,
//     labels: false,
//     tooltip: false,
//     step: step, // step size
//     disabled: false, // is disabled?
//     onChange: sliderChange, // callback
//   });

//   // Set sliderInteraction to true after a delay to avoid triggering on initial load or rebuild
//   setTimeout(() => {
//     sliderInteraction = true;
//   }, 750); // Increased from 500ms to 750ms for better safety
// }

// function sliderChange(values) {
//   // Only trigger filter change if user has actually interacted with the slider
//   if (!sliderInteraction) {
//     console.log("Slider change ignored - no user interaction yet");
//     return;
//   }

//   // Additional safety check: don't trigger if values are at the extremes (default state)
//   let valuesArray = values.split(",");
//   let minVal = Number(valuesArray[0]);
//   let maxVal = Number(valuesArray[1]);

//   // If slider is at full range (min to max), don't trigger a filter
//   if (
//     priceRange.length > 0 &&
//     minVal === priceRange[0] &&
//     maxVal === priceRange[priceRange.length - 1]
//   ) {
//     console.log("Slider at full range - no filter needed");
//     return;
//   }

//   if (window.innerWidth < 860) showLoadingSpinner();
//   let sliderMinMax = `minMaxPrice_${minVal}_${maxVal}`;
//   currentFilters = currentFilters.filter((item) => item.includes("minMaxPrice") === false);
//   currentFilters.push(sliderMinMax);
//   window.location.href = buildHref(1);
// }

// function filterOptionSearchChange() {
//   let lastSelectedFilterKey = lastInteraction != undefined ? lastInteraction : null;
//   let search = this.value.toLowerCase().trim();
//   let searchResult;
//   let filterKey;

//   if (search) {
//     filterKey = this.getAttribute("data-filter-key");
//     let filterOptions = enabledFilters.find((item) => item.key === filterKey).options;
//     let enabledFilterOptions = [...filterOptions];
//     if (lastSelectedFilterKey == filterKey) {
//       let cachedEnabledFilter = cachedFilters.filters?.find((f) => f.key == filterKey);
//       if (cachedEnabledFilter) {
//         enabledFilterOptions = [...cachedEnabledFilter.options];
//       }
//     }

//     let count = 0;
//     searchResult = enabledFilterOptions.filter((option) => {
//       if (count < 100) {
//         if (option.value.toLowerCase().search(search) >= 0) {
//           count++;
//           return option;
//         }
//       }
//     });
//   }

//   // Find containers - support both old and new structure
//   let searchContainer =
//     this.parentElement.querySelector(".facet-filters__search-results") ||
//     this.parentElement.querySelector(".etempa-filter-search-results-container");
//   let optionsContainer =
//     this.parentElement.querySelector(".facet-filters__main-options") ||
//     this.parentElement.querySelector(".etempa-filter-options-container");

//   if (!searchContainer || !optionsContainer) return;

//   searchContainer.innerHTML = "";

//   if (search) {
//     optionsContainer.style.display = "none";
//     searchContainer.style.display = "block";

//     if (searchResult && searchResult.length > 0) {
//       // Check if we're using new structure (facets) or old structure
//       const isNewStructure = searchContainer.classList.contains("facet-filters__search-results");

//       if (isNewStructure) {
//         // Use new structure - create fieldset and ul like the main options
//         const config = window.facetConfig;
//         const texts = window.facetTexts;

//         let fieldset = document.createElement("fieldset");
//         fieldset.classList.add(
//           "facets-wrap",
//           "parent-wrap",
//           "facets-wrap-vertical",
//           "facet-filters__main-options",
//         );

//         let ul = document.createElement("ul");
//         ul.className = config.classes.facetsList;
//         ul.setAttribute("role", "list");
//         fieldset.appendChild(ul);
//         searchContainer.appendChild(fieldset);

//         // Render each search result using the same structure as main options
//         searchResult.forEach((option, optionIndex) => {
//           let isActive = currentFilters.includes(
//             `${filterKey}_${encodeURIComponent(option.value)}`,
//           );

//           let li = document.createElement("li");
//           li.className = config.classes.facetsItem;

//           let label = document.createElement("label");
//           label.setAttribute("for", `Filter-Search-${filterKey}-${optionIndex}`);
//           label.className = `${config.classes.facetsLabel}${isActive ? " active" : ""}`;

//           let input = document.createElement("input");
//           input.type = "checkbox";
//           input.name = filterKey;
//           input.value = option.value;
//           input.id = `Filter-Search-${filterKey}-${optionIndex}`;
//           if (isActive) {
//             input.checked = true;
//           }
//           input.addEventListener("change", function () {
//             filterOptionChange(filterKey, option.value, this.checked);
//           });

//           label.appendChild(input);

//           let highlight = document.createElement("span");
//           highlight.className = config.classes.mobileHighlight;
//           label.appendChild(highlight);

//           let square = document.createElement("span");
//           square.className = config.classes.mobileSquare;
//           label.appendChild(square);

//           let checkmarkSpan = document.createElement("span");
//           checkmarkSpan.innerHTML = config.icons.checkmark;
//           label.appendChild(checkmarkSpan);

//           let textSpan = document.createElement("span");
//           textSpan.className = "facet-checkbox__text";
//           textSpan.setAttribute("aria-hidden", "true");

//           let textLabel = document.createElement("span");
//           textLabel.className = "facet-checkbox__text-label";
//           textLabel.textContent = option.value;
//           textSpan.appendChild(textLabel);

//           label.appendChild(textSpan);

//           if (option.count !== undefined) {
//             let hiddenSpan = document.createElement("span");
//             hiddenSpan.className = "visually-hidden";
//             hiddenSpan.textContent = ` (${option.count})`;
//             label.appendChild(hiddenSpan);
//           }

//           li.appendChild(label);
//           ul.appendChild(li);
//         });
//       } else {
//         // Use old structure for backward compatibility
//         searchResult.forEach((option) => populateOptions(filterKey, option.value, searchContainer));
//       }
//     } else if (search) {
//       // No results found
//       let noResults = document.createElement("div");
//       noResults.className = "facet-filters__no-results";
//       noResults.textContent = "No matching filters found";
//       searchContainer.appendChild(noResults);
//     }
//   } else {
//     optionsContainer.style.display = "block";
//     searchContainer.style.display = "none";
//   }
// }

// function getHiddenHeight(el) {
//   if (!el?.cloneNode) {
//     return null;
//   }

//   const clone = el.cloneNode(true);

//   Object.assign(clone.style, {
//     overflow: "visible",
//     height: "auto",
//     maxHeight: "none",
//     opacity: "0",
//     visibility: "hidden",
//     display: "block",
//   });

//   el.after(clone);
//   const height = clone.offsetHeight;

//   clone.remove();

//   return height;
// }

function buildHref(targetPage) {
  let params = new URLSearchParams();
  params.append("page", targetPage);
  params.append("view", limit);
  params.append("grid_list", view);
  params.append("sort_by", sort);
  if (currentFilters.length > 0) {
    currentFilters.forEach((filter) => params.append("filter", filter));
  }
  let href = `/collections/${collection_handle}?${params.toString()}`;
  return href;
}

// function createActiveFilters() {
//   // Get the active facets container from the Liquid template
//   const activeFiltersVertical = document.querySelector(".active-facets-vertical-filter");
//   const activeFiltersDesktop = document.querySelector(".active-facets-desktop");
//   const activeFiltersMobile = document.querySelector(".active-facets-mobile");

//   if (!activeFiltersVertical || !activeFiltersDesktop || !activeFiltersMobile) return;

//   // Clear existing active filter pills (but keep the heading and clear all button)
//   const existingDesktopPills = activeFiltersDesktop.querySelectorAll(
//     "facet-remove:not(.active-facets__button-wrapper)",
//   );
//   existingDesktopPills.forEach((pill) => pill.remove());

//   const existingMobilePills = activeFiltersMobile.querySelectorAll(
//     "facet-remove:not(.active-facets__button-wrapper)",
//   );
//   existingMobilePills.forEach((pill) => pill.remove());

//   // Clear existing "Clear all" button
//   const existingClearAll = activeFiltersVertical.querySelector(".active-facets__button-wrapper");
//   if (existingClearAll) {
//     existingClearAll.remove();
//   }

//   // Add "Clear all" button if there are active filters
//   if (currentFilters.length > 0) {
//     const config = window.facetConfig || {};
//     const texts = window.facetTexts || {};

//     // Create "Clear all" button (matches facets-new.liquid structure)
//     let clearAllWrapper = document.createElement("facet-remove");
//     clearAllWrapper.className = "active-facets__button-wrapper";

//     let clearAllLink = document.createElement("a");
//     clearAllLink.href = buildHref(1, true); // Build URL with no filters
//     clearAllLink.className = "active-facets__button-remove underlined-link";
//     clearAllLink.addEventListener("click", function (e) {
//       e.preventDefault();
//       clearFilters();
//     });

//     let clearAllSpan = document.createElement("span");
//     clearAllSpan.textContent = texts.clearAll || "Clear all";
//     clearAllLink.appendChild(clearAllSpan);

//     clearAllWrapper.appendChild(clearAllLink);
//     activeFiltersVertical.appendChild(clearAllWrapper);

//     if (activeFiltersMobile) {
//       const clearAllMobile = clearAllWrapper.cloneNode(true);
//       const mobileClearLink = clearAllMobile.querySelector("a");
//       mobileClearLink.addEventListener("click", function (e) {
//         e.preventDefault();
//         clearFilters();
//       });
//       activeFiltersMobile.appendChild(clearAllMobile);
//     }

//     // Create active filter pills for each active filter
//     currentFilters.forEach((filter) => {
//       let filterArray = filter.split("_");
//       let filterKey = filterArray[0];
//       let filterValue = decodeURIComponent(filterArray[1]);

//       // Find the filter label from enabledFilters
//       let filterLabel = filterKey;
//       if (filterKey === "minMaxPrice") {
//         filterValue = `${filterArray[1]}_${filterArray[2]}`; // Combine min and max
//       }

//       if (enabledFilters && Array.isArray(enabledFilters)) {
//         let filterObj = enabledFilters.find((f) => f.key === filterKey);
//         if (filterObj) {
//           filterLabel = filterObj.label || filterKey;
//         }
//       }

//       // Create facet-remove pill (matches facets-new.liquid structure)
//       let facetRemove = document.createElement("facet-remove");

//       let removeLink = document.createElement("a");
//       removeLink.href = buildHrefWithoutFilter(filterKey, filterValue);
//       removeLink.className = "active-facets__button active-facets__button--light";
//       removeLink.addEventListener("click", function (e) {
//         e.preventDefault();
//         removeFilterOption(filterKey, filterValue);
//       });

//       let buttonInner = document.createElement("span");
//       buttonInner.className = "active-facets__button-inner button button--tertiary";

//       // Add filter label and value
//       let labelText;

//       if (filterKey === "minMaxPrice") {
//         let filterMin = filterArray[1];
//         let filterMax = filterArray[2];
//         labelText = document.createTextNode(
//           `PRICE: ${currencySymbol}${filterMin}-${currencySymbol}${filterMax}`,
//         );
//         buttonInner.append(labelText);
//       } else {
//         labelText = document.createTextNode(`${filterLabel}: ${filterValue}`);
//         buttonInner.append(labelText);
//       }

//       // Add close icon
//       let closeIconSpan = document.createElement("span");
//       closeIconSpan.innerHTML = config.icons?.close || "×";
//       buttonInner.appendChild(closeIconSpan);

//       // Add visually hidden text
//       let visuallyHidden = document.createElement("span");
//       visuallyHidden.className = "visually-hidden";
//       visuallyHidden.textContent = texts.clearFilter || "Clear filter";
//       buttonInner.appendChild(visuallyHidden);

//       removeLink.appendChild(buttonInner);
//       facetRemove.appendChild(removeLink);
//       activeFiltersDesktop.appendChild(facetRemove);

//       if (activeFiltersMobile) {
//         const facetRemoveMobile = facetRemove.cloneNode(true);
//         const mobileLink = facetRemoveMobile.querySelector("a");
//         mobileLink.addEventListener("click", function (e) {
//           e.preventDefault();
//           removeFilterOption(filterKey, filterValue);
//         });
//         activeFiltersMobile.appendChild(facetRemoveMobile);
//       }
//     });

//     setMobileFilterText();
//   }
// }

// Updated removeFilterOption to accept parameters
// function removeFilterOption(filterKey, filterValue) {
//   let target = `${filterKey}_${encodeURIComponent(filterValue)}`;
//   currentFilters = currentFilters.filter((item) => item !== target);
//   localStorage.removeItem("klevuCollectionCachedInteraction");
//   window.location.href = buildHref(1);
// }

// Helper function to build URL without a specific filter
// function buildHrefWithoutFilter(filterKey, filterValue) {
//   let target = `${filterKey}_${encodeURIComponent(filterValue)}`;
//   let tempFilters = currentFilters.filter((item) => item !== target);

//   let params = new URLSearchParams();
//   tempFilters.forEach((filter) => {
//     let filterArray = filter.split("_");
//     let key = filterArray[0];
//     let value = decodeURIComponent(filterArray[1]);
//     params.append(key, value);
//   });

//   return `/collections/${collection_handle}?${params.toString()}`;
// }

// function removeFilterOption(e) {
//     e.preventDefault();
//     if(filter_form.classList.contains('loading')) return
//     filter_form.classList.add('loading')
//     let filterKey = this.getAttribute('data-filter-key');
//     let filterValue = this.getAttribute('data-filter-value');
//     let target = `${filterKey}_${encodeURIComponent(filterValue)}`;
//     currentFilters = currentFilters.filter(item => item !== target);
//     this.style.display = 'none';
//     // console.log(currentFilters);
//     localStorage.removeItem('klevuCollectionCachedInteraction');
//     window.location.href = buildHref(1);
// }

// function clearFilters(e) {
//   currentFilters = [];
//   // console.log(currentFilters);
//   localStorage.removeItem("klevuCollectionCachedInteraction");
//   window.location.href = buildHref(1);
// }

// function mobileFilterButtonEvent() {
//   if (mobile_filter_button) {
//     mobile_filter_button.addEventListener("click", function (e) {
//       modalFirstGroupHeightInterval = setInterval(setModalFirstGroupHeight, 500);
//     });
//   }
// }

// function setModalFirstGroupHeight() {
//   let activeLists = document
//     .querySelector(".modal--productgrid-filters")
//     ?.querySelectorAll(".productgrid--sidebar-button-active");
//   if (activeLists) {
//     activeLists.forEach((list) => {
//       let listElem = list.parentElement.querySelector(".collection-filters__filter-list");
//       listElem.style.height =
//         getHiddenHeight(listElem) < 1 ? "auto" : `${getHiddenHeight(listElem)}px`;
//     });
//     if (priceSlider) {
//       priceSlider.destroy();
//       buildPriceSlider();
//     }
//     if (currentFilters.length > 0) addClearAllButton();
//     clearInterval(modalFirstGroupHeightInterval);
//   }
// }

// function addClearAllButton() {
//   let modalContent = document.querySelector(".modal-content");
//   let mobileClearAll = document.createElement("a");
//   mobileClearAll.classList.add("filter-item-clear-all", "mobile-clear-all");
//   mobileClearAll.innerText = "Clear All";
//   mobileClearAll.setAttribute("href", collection_url);
//   mobileClearAll.addEventListener("click", showLoadingSpinner);
//   modalContent.insertBefore(mobileClearAll, modalContent.querySelector(".filter-form"));
// }

function setMobileFilterText() {
  if (mobile_filter_text) {
    mobile_filter_text.innerText = `Filters (${currentFilters.length})`;
  }
}

// function windowResizeEvent() {
//   let resizeTimeout;
//   window.addEventListener("resize", function () {
//     // Debounce resize events to avoid multiple rebuilds
//     clearTimeout(resizeTimeout);
//     resizeTimeout = setTimeout(() => {
//       if (priceSlider) {
//         sliderInteraction = false; // Ensure interaction is disabled before rebuild
//         priceSlider.destroy();
//         buildPriceSlider();
//       }
//     }, 250); // Wait 250ms after resize stops before rebuilding
//   });
// }

// function checkForMultipleVariants(variantCountArray) {
//   variantCountArray.forEach((variantCountRow) => {
//     if (parseInt(variantCountRow.variant_count) > 1) {
//       let productCard = document.querySelector(
//         `.productgrid--item[data-product-id='${variantCountRow.product_id}']`,
//       );
//       if (productCard != null) {
//         swapButtonForLink(productCard, variantCountRow.available);
//       }
//     }
//   });
// }

// function swapButtonForLink(productCard, isAvailable) {
//   let imageLink = productCard.querySelector(".productitem--image-link");
//   let link = imageLink.getAttribute("href");

//   let atcButton = productCard.querySelector(".productitem--action-atc");
//   let atcButtonContainer = productCard.querySelector(".productitem--action.atc--button");
//   let buttontext = "Choose Options";
//   if (atcButton.classList.contains("disabled") && !isAvailable) {
//     return;
//   } else if (atcButton.classList.contains("disabled") && isAvailable) {
//     let soldOutBadge = productCard.querySelector(".soldout-badge");
//     if (soldOutBadge) {
//       soldOutBadge.remove();
//     }
//     let productStockLevelWrapper = productCard.querySelector(".product-stock-level-wrapper");
//     let productItemStockLevelSpan = document.createElement("span");
//     productItemStockLevelSpan.classList.add("product-stock-levels", "product-stock-level--high");
//     productItemStockLevelSpan.innerHTML = `<span class="product-stock-level__text"><div class="product-stock-level__badge-text">Available</div></span>`;
//     productStockLevelWrapper.append(productItemStockLevelSpan);
//   }
//   atcButtonContainer.innerHTML = `
//     <a href='${link}' class="productitem--action-trigger productitem--action-atc button-primary mdc-ripple-surface mdc-ripple-upgraded" aria-label="${buttontext}">
//         ${buttontext}
//     </a>
//     `;
// }

/** currency conversion */

// const arrayChunk = (arr, size) =>
//   Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
//     arr.slice(i * size, i * size + size),
//   );

// function etempaKlevuSendCategoryData() {
//   var klevu_cat_name = window.klevu_cat_name;
//   var klevu_cat_url = window.klevu_cat_url;

//   //storage
//   var category = klevu.dictionary("category");
//   category.setStorage("local");
//   category.mergeFromGlobal();
//   category.addElement("klevu_categoryName", klevu_cat_name);
//   category.addElement("klevu_categoryUrl", klevu_cat_url);
//   category.addElement("klevu_categoryProducts", klevuProducts);
//   category.mergeToGlobal();

//   var klevuCategoryOptions = {
//     klevu_categoryName: klevu_cat_name,
//     klevu_categoryPath: klevu_cat_name,
//     klevu_productIds: klevuProducts.join(","),
//   };

//   klevu.coreEvent.attach("analyticsPowerUpShopifyPL", {
//     name: "attachShopifyPLListingAnalytics",
//     fire: function () {
//       klevu.analyticsUtilShopifyPL.base.sendCatViewAnalyticsRequest(klevuCategoryOptions);
//     },
//   });
// }
